import { useItem } from './hooks/use-context';

export function Providences() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  // Helper function to get selected providence options from a checkbox_combo question
  const getSelectedProvidences = (questionId: string) => {
    const question = questions.find((q) => q.question_id === questionId);
    return question?.answers || [];
  };

  // Helper function to get child question content by type and parent option ID
  const getChildQuestionContent = (
    parentOptionId: string,
    questionType: string,
  ) => {
    const childQuestion = questions.find(
      (q) =>
        q.type === questionType &&
        q.answers.some(
          (answer) => answer.question_parent_option_id === parentOptionId,
        ),
    );
    return childQuestion?.answers?.[0]?.content || '';
  };

  // Helper function to render a table
  const renderTable = (title: string, questionId: string) => {
    const selectedProvidences = getSelectedProvidences(questionId);
    const totalRows = 3; // Always show 3 rows

    // Create an array of 3 items, filling with actual data or empty objects
    const tableRows = Array.from({ length: totalRows }, (_, index) => {
      const providence = selectedProvidences[index];
      if (providence) {
        const optionId = providence.option_id || providence.content;
        return {
          id: (index + 1).toString().padStart(2, '0'),
          description: getChildQuestionContent(optionId, 'paragraph'),
          responsible: getChildQuestionContent(optionId, 'text'),
          deadline: getChildQuestionContent(optionId, 'date'),
          key: optionId,
        };
      }
      return {
        id: (index + 1).toString().padStart(2, '0'),
        description: '',
        responsible: '',
        deadline: '',
        key: `empty-${index}`,
      };
    });

    return (
      <div style={{ marginBottom: '20px', breakInside: 'avoid' }}>
        <h3
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            marginBottom: '10px',
            color: '#333',
          }}
        >
          {title}
        </h3>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #ddd',
            marginBottom: '10px',
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#FAE0CD',
                  width: '10%',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                ID
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#FAE0CD',
                  width: '50%',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                Providência
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#FAE0CD',
                  width: '20%',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                Responsável
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: '8px',
                  textAlign: 'center',
                  backgroundColor: '#FAE0CD',
                  width: '20%',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                Prazo
              </th>
            </tr>
          </thead>
          <tbody>
            {tableRows.map((row) => (
              <tr key={row.key}>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: '12px',
                  }}
                >
                  {row.id}
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    fontSize: '12px',
                    minHeight: '40px',
                  }}
                >
                  {row.description}
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    fontSize: '12px',
                    minHeight: '40px',
                  }}
                >
                  {row.responsible}
                </td>
                <td
                  style={{
                    border: '1px solid #ddd',
                    padding: '8px',
                    fontSize: '12px',
                    minHeight: '40px',
                  }}
                >
                  {row.deadline}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // Get general observations
  const generalObservations =
    questions.find(
      (q) => q.question_id === 'eb7bb0ac-ed9e-4253-a113-90d365d23f5b',
    )?.answers?.[0]?.content || '';

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        marginBottom: '20px',
        padding: '10px',
      }}
    >
      {/* Immediate Providences */}
      {renderTable(
        'Providências Imediatas (Início Imediato)',
        '094c3f89-7705-4cdd-8ad3-1e5e9c9813a5',
      )}

      {/* Post-60 Days Providences */}
      {renderTable(
        'Providências (Conclusão após 60 dias da ocorrência)',
        '572cda07-b059-4b4b-bf80-279165477f4a',
      )}

      {/* General Observations */}
      {generalObservations && (
        <div
          style={{
            marginTop: '20px',
          }}
        >
          <h3
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '10px',
              color: '#333',
            }}
          >
            Observações Gerais:
          </h3>
          <div
            style={{
              border: '1px solid #ddd',
              borderRadius: '5px',
              backgroundColor: '#FFFFFF',
              padding: '10px',
              minHeight: '60px',
              fontSize: '12px',
            }}
          >
            {generalObservations}
          </div>
        </div>
      )}
    </div>
  );
}
